var map = {
	"./arrow-down.svg": "zpNP",
	"./backto.png": "XWe5",
	"./del.png": "Ub/c",
	"./department/bg.png": "i3/N",
	"./department/bg_x2.png": "JhDK",
	"./department/department_icon_0.png": "029q",
	"./department/department_icon_1.png": "ehOV",
	"./department/department_icon_2.png": "uBN9",
	"./department/department_icon_3.png": "MtOm",
	"./department/department_icon_4.png": "P9X2",
	"./department/department_icon_5.png": "zosb",
	"./department/department_icon_6.png": "csuF",
	"./department/department_icon_7.png": "Z1e+",
	"./department/department_icon_9.png": "6p51",
	"./department/logo.png": "olxk",
	"./department/logo_txt.png": "sPu8",
	"./department/logo_txt_x2.png": "Rf/4",
	"./department/logo_x2.png": "aDy3",
	"./doctor.svg": "WhZd",
	"./folder.svg": "VqkA",
	"./hide1.png": "rZvE",
	"./icon-add.png": "xpjE",
	"./icon-del.png": "jyCs",
	"./invite.png": "Abig",
	"./line.png": "eRT6",
	"./lock.png": "ybzx",
	"./login-background.jpg": "fifj",
	"./login.png": "6QGk",
	"./logo.png": "7Otq",
	"./logo3.png": "mCmD",
	"./logo_txt.png": "zC8j",
	"./logo_txt_x2.png": "MhWi",
	"./logout.png": "R+99",
	"./menu-nav/account_manage.png": "lewa",
	"./menu-nav/account_manage_active.png": "D14Z",
	"./menu-nav/create_orders.png": "8XLR",
	"./menu-nav/create_orders_active.png": "GRCR",
	"./menu-nav/hospital_manage.png": "KrfK",
	"./menu-nav/hospital_manage_active.png": "0jgC",
	"./menu-nav/log_audit.png": "3Qvc",
	"./menu-nav/log_audit_active.png": "zqXN",
	"./menu-nav/logo.png": "LvSN",
	"./menu-nav/orders.png": "s2Wq",
	"./menu-nav/orders_active.png": "WnM3",
	"./mode_qr_bg.png": "DY5s",
	"./mode_qr_bg_x2.png": "+DgK",
	"./phone.png": "UqHI",
	"./qr_code.png": "ZZ9i",
	"./relock.png": "GfSL",
	"./shelf-list/collapse.png": "Pmgj",
	"./shelf-list/expand.png": "Jj4o",
	"./stl_qr_back_1x.png": "hsQa",
	"./stl_qr_back_2x.png": "2gD5",
	"./suc.png": "8yL3",
	"./view1.png": "9atS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "csn8";


//////////////////
// WEBPACK FOOTER
// ./src/assets \.(png|jpe?g|gif|svg|mp4|webm|ogg|mp3|wav|flac|aac|woff2?|eot|ttf|otf)$
// module id = csn8
// module chunks = 1